import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { configure } from 'mobx';

import '@vromo/analytics/bugsnag';
import VromoRouter from './VromoRouter';

import rootStore from '../stores/RootStore';

import { Provider } from '@vromo/mobx-react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import Unbounce from '@vromo/analytics/Unbounce';
import Capterra from '@vromo/analytics/Capterra';
import * as HubSpot from '@vromo/analytics/HubSpot';
import '../i18n/i18n';
import Bugsnag from '@vromo/analytics/bugsnag';
import ReactGA from 'react-ga4';

// configure({ enforceActions: 'observed' });

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

window.onload = () => {
    const host = document.body.appendChild(document.createElement('div'));
    host.style.height = '100%';
    host.id = 'root';

    render(
        <React.StrictMode>
            <ErrorBoundary>
                <DndProvider backend={HTML5Backend}>
                    <Suspense fallback={<div />}>
                        <Provider rootStore={rootStore}>
                            <VromoRouter />
                        </Provider>
                    </Suspense>
                </DndProvider>
            </ErrorBoundary>
        </React.StrictMode>,
        host
    );

    Unbounce.track();
    Capterra.track();
    HubSpot.removeChatWidget();
};
